<template>
  <transition enter-active-class="ease-out duration-300" enter-class="opacity-0" enter-to-class="opacity-100"
              leave-active-class="ease-in duration-200" leave-class="opacity-100" leave-to-class="opacity-0">
    <div v-show="modelValue" class="modal fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
      <div class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
      <div
          class="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto m-24">
        <div
            class="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50"
            @click="close">
          <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18"
               viewBox="0 0 18 18">
            <path
                d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
          </svg>
          <span class="text-sm">(Esc)</span>
        </div>

        <div class="modal-content py-6 text-left px-6" style="max-height: 99vh">
          <div class="flex justify-between">
            <div>
              <slot name="title"></slot>
            </div>
            <div class="modal-close cursor-pointer z-50" @click="close">
              <svg class="fill-current text-black" xmlns="http://www.w3.org/2000/svg" width="18"
                   height="18" viewBox="0 0 18 18">
                <path
                    d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
              </svg>
            </div>
          </div>
          <slot>Empty content</slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "UiModal",
  props: {
    modelValue: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    modelValue(value) {
      if (value) document.addEventListener("keydown", this.escEvent);
      else document.removeEventListener('keydown', this.escEvent)
    }
  },
  methods: {
    close() {
      this.$emit('update:modelValue', false);
    },
    escEvent(e) {
      if (e.keyCode === 27) {
        console.log(e)
        this.close();
      }
    },
  },

}
</script>

<style scoped>

</style>